import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Autocomplete,
  TextField,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TambahUser = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch, setting } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [kodeCabang, setKodeCabang] = useState("");
  const [namaPeriode, setNamaPeriode] = useState("");
  const [username, setUsername] = useState("");
  const [tipeUser, setTipeUser] = useState("");
  const [kodeMarketing, setKodeMarketing] = useState("");
  const [kodeSurveyor, setKodeSurveyor] = useState("");
  const [kodeKwitansi, setKodeKwitansi] = useState("");
  const [coaKasir, setCoaKasir] = useState("");
  const [password, setPassword] = useState("");

  // Akses Master
  const [jaminan, setJaminan] = useState(false);
  const [marketing, setMarketing] = useState(false);
  const [bukuBesar, setBukuBesar] = useState(false);
  const [area, setArea] = useState(false);
  const [customer, setCustomer] = useState(false);
  const [surveyor, setSurveyor] = useState(false);
  const [eksekutor, setEksekutor] = useState(false);
  const [tipe, setTipe] = useState(false);
  const [warna, setWarna] = useState(false);
  const [tingkatRisiko, setTingkatRisiko] = useState(false);
  const [kualitasPiutang, setKualitasPiutang] = useState(false);
  const [cabang, setCabang] = useState(false);

  // Akses Gadai
  const [pengajuan, setPengajuan] = useState(false);
  const [approval, setApproval] = useState(false);
  const [buktiPencairan, setBuktiPencairan] = useState(false);
  const [topup, setTopup] = useState(false);
  const [tebus, setTebus] = useState(false);
  const [perpanjangan, setPerpanjangan] = useState(false);
  const [cicilan, setCicilan] = useState(false);
  const [jualAgunan, setJualAgunan] = useState(false);
  const [infoNasabahGadai, setInfoNasabahGadai] = useState(false);

  // Akses Laporan Gadai
  const [lapTunggakan, setLapTunggakan] = useState(false);
  const [lapTunggakanRinci, setLapTunggakanRinci] = useState(false);
  const [lapOutstanding, setLapOutstanding] = useState(false);
  const [lapPinjamanJatuhTempo, setLapPinjamanJatuhTempo] = useState(false);
  const [lapStockSiapDijual, setLapStockSiapDijual] = useState(false);
  const [lapPenerimaan, setLapPenerimaan] = useState(false);
  const [lapJualBarang, setLapJualBarang] = useState(false);
  const [lapOutstandingGadai, setLapOutstandingGadai] = useState(false);
  const [lapPiutangLunasGadai, setLapPiutangLunasGadai] = useState(false);
  const [lapPendapatanByadGadai, setLapPendapatanByadGadai] = useState(false);
  const [lapTopupGadai, setLapTopupGadai] = useState(false);
  const [lapTebusGadai, setLapTebusGadai] = useState(false);
  const [lapPerpanjanganGadai, setLapPerpanjanganGadai] = useState(false);

  // Akses Fidusia
  const [registerFidusia, setRegisterFidusia] = useState(false);
  const [surveyFidusia, setSurveyFidusia] = useState(false);
  const [surveyManagerFidusia, setSurveyManagerFidusia] = useState(false);
  const [pengajuanFidusia, setPengajuanFidusia] = useState(false);
  const [approvalFidusia, setApprovalFidusia] = useState(false);
  const [buktiPencairanFidusia, setBuktiPencairanFidusia] = useState(false);
  const [angsuranFidusia, setAngsuranFidusia] = useState(false);
  const [percepatanFidusia, setPercepatanFidusia] = useState(false);
  const [hutangDendaFidusia, setHutangDendaFidusia] = useState(false);
  const [ubahHutangDendaFidusia, setUbahHutangDendaFidusia] = useState(false);
  const [infoNasabahFidusia, setInfoNasabahFidusia] = useState(false);
  const [penarikanFidusia, setPenarikanFidusia] = useState(false);
  const [sp1, setSp1] = useState(false);
  const [sp2, setSp2] = useState(false);
  const [sp3, setSp3] = useState(false);
  const [sPanggilan, setSPanggilan] = useState(false);
  const [sPenarikan, setSPenarikan] = useState(false);

  // Akses Laporan Fidusia
  const [lapTunggakanFidusia, setLapTunggakanFidusia] = useState(false);
  const [lapTunggakanFidusiaRinci, setLapTunggakanFidusiaRinci] =
    useState(false);
  const [lapTotalPiutangFidusia, setLapTotalPiutangFidusia] = useState(false);
  const [lapPinjamanJatuhTempoFidusia, setLapPinjamanJatuhTempoFidusia] =
    useState(false);
  const [lapPenerimaanFidusia, setLapPenerimaanFidusia] = useState(false);
  const [lapOutstandingFidusia, setLapOutstandingFidusia] = useState(false);
  const [lapPiutangLunasFidusia, setLapPiutangLunasFidusia] = useState(false);
  const [lapPenarikanFidusia, setLapPenarikanFidusia] = useState(false);
  const [lapPendapatanByadFidusia, setLapPendapatanByadFidusia] =
    useState(false);
  const [lapPoint6Bulan, setLapPoint6Bulan] = useState(false);
  const [lapNplFidusia, setLapNplFidusia] = useState(false);
  const [lapHutangDendaFidusia, setLapHutangDendaFidusia] = useState(false);
  const [lapTunggakanFidusiaOjk, setLapTunggakanFidusiaOjk] = useState(false);
  const [lapTunggakanFidusiaRinciOjk, setLapTunggakanFidusiaRinciOjk] =
    useState(false);

  // Finance
  const [kasMasuk, setKasMasuk] = useState(false);
  const [kasKeluar, setKasKeluar] = useState(false);
  const [bankMasuk, setBankMasuk] = useState(false);
  const [bankKeluar, setBankKeluar] = useState(false);

  // Accounting
  const [posting, setPosting] = useState(false);
  const [unposting, setUnposting] = useState(false);
  const [aktivitasBukuBesar, setAktivitasBukuBesar] = useState(false);
  const [neracaSaldo, setNeracaSaldo] = useState(false);
  const [labaRugiRekap, setLabaRugiRekap] = useState(false);
  const [labaRugi, setLabaRugi] = useState(false);
  const [neraca, setNeraca] = useState(false);
  const [arusKasRekap, setArusKasRekap] = useState(false);
  const [jurnalUmum, setJurnalUmum] = useState(false);
  const [jurnal, setJurnal] = useState(false);

  // Accounting OJK
  const [labaRugiOjk, setLabaRugiOjk] = useState(false);
  const [neracaOjk, setNeracaOjk] = useState(false);
  const [arusKasOjk, setArusKasOjk] = useState(false);

  // Akses Utility
  const [profilUser, setProfilUser] = useState(false);
  const [daftarUser, setDaftarUser] = useState(false);
  const [tutupPeriode, setTutupPeriode] = useState(false);
  const [gantiPeriode, setGantiPeriode] = useState(false);
  const [settingAkses, setSettingAkses] = useState(false);

  // Check All Akses
  const [checkAll, setCheckAll] = useState(false);

  const [marketings, setMarketings] = useState([]);
  const [surveyors, setSurveyors] = useState([]);
  const [cabangs, setCabangs] = useState([]);
  const [coaSubTunais, setCoaSubTunais] = useState([]);
  const [periodesData, setPeriodesData] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [openAlertUsername, setOpenAlertUsername] = useState(false);
  const [openAlertKodeKwitansiCabang, setOpenAlertKodeKwitansiCabang] =
    useState(false);

  const handleClickOpenAlertUsername = () => {
    setOpenAlertUsername(true);
  };

  const handleCloseAlertUsername = () => {
    setOpenAlertUsername(false);
  };

  const handleClickOpenAlertKodeKwitansiCabang = () => {
    setOpenAlertKodeKwitansiCabang(true);
  };

  const handleCloseAlertKodeKwitansiCabang = () => {
    setOpenAlertKodeKwitansiCabang(false);
  };

  const tipeUserOption = ["MANAGER", "ADMIN", "MARKETING", "SURVEYOR"];
  const tipeUserOptionOwner = [
    "OWNER/DIREKSI",
    "MANAGER",
    "ADMIN",
    "MARKETING",
    "SURVEYOR",
  ];
  const marketingOptions = marketings.map((marketing) => ({
    label: `${marketing.kodeMarketing} - ${marketing.namaMarketing}`,
  }));
  const surveyorOptions = surveyors.map((surveyor) => ({
    label: `${surveyor.kodeSurveyor} - ${surveyor.namaSurveyor}`,
  }));
  let coaOptions = coaSubTunais.map((coa) => ({
    label: `${coa.kodeCOA} - ${coa.namaCOA}`,
  }));
  let periodeOptions = periodesData.map((periode) => ({
    label: periode.namaPeriode,
  }));

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    getMarketing();
    getSurveyor();
    getPeriodesData();
    getCabangsData();
    getCoaSubTunai();
  }, []);

  const getMarketing = async () => {
    setLoading(true);
    const allMarketings = await axios.post(`${tempUrl}/marketings`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabangId,
    });
    setMarketings(allMarketings.data);
    setLoading(false);
  };

  const getSurveyor = async () => {
    setLoading(true);
    const allSurveyors = await axios.post(`${tempUrl}/surveyors`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabangId,
    });
    setSurveyors(allSurveyors.data);
    setLoading(false);
  };

  const getPeriodesData = async () => {
    setLoading(true);
    try {
      const allPeriode = await axios.post(`${tempUrl}/tutupPeriodesAsc`, {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabangId,
      });
      setPeriodesData(allPeriode.data);
      if (user.tipeUser === "OWNER/DIREKSI") {
        setTipeUser(tipeUserOptionOwner[0]);
      } else {
        setTipeUser(tipeUserOption[0]);
      }
    } catch (error) {
      alert(error);
    }
    setLoading(false);
  };

  const getCabangsData = async (kodeUnit) => {
    setKodeCabang("");
    const response = await axios.post(`${tempUrl}/cabangs`, {
      _id: user.id,
      token: user.token,
    });
    setCabangs(response.data);
    if (user.tipeUser === "OWNER/DIREKSI") {
      setKodeCabang(response.data[0].id);
    } else {
      setKodeCabang(user.cabang.id);
    }
  };

  const getCoaSubTunai = async (kodeUnit) => {
    const response = await axios.post(`${tempUrl}/COAsSubGroup`, {
      _id: user.id,
      token: user.token,
      kodeSubGroupCOA: setting.subGroupCoaKas,
    });
    setCoaSubTunais(response.data);
  };

  const saveUser = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    let isFailedValidation =
      form.checkValidity() || coaKasir.length !== 0 || namaPeriode.length !== 0;

    if (tipeUser === "MARKETING") {
      isFailedValidation =
        form.checkValidity() ||
        kodeMarketing.length === 0 ||
        coaKasir.length !== 0 ||
        namaPeriode.length !== 0;
    }

    if (tipeUser === "SURVEYOR") {
      isFailedValidation =
        form.checkValidity() ||
        kodeSurveyor.length === 0 ||
        coaKasir.length !== 0 ||
        namaPeriode.length !== 0;
    }

    if (isFailedValidation) {
      setLoading(true);
      try {
        let tempUsername = await axios.post(`${tempUrl}/getUsername`, {
          username,
          _id: user.id,
          token: user.token,
        });
        let tempKodeKwitansi = await axios.post(`${tempUrl}/getKodeKwitansi`, {
          kodeKwitansi,
          _id: user.id,
          token: user.token,
          kodeCabang,
        });

        let isUsernameAlreadyExist = tempUsername.data.length > 0;
        let isKodeKwitansiCabangAlreadyExist = tempKodeKwitansi.data.length > 0;
        if (isUsernameAlreadyExist) {
          handleClickOpenAlertUsername();
        } else if (isKodeKwitansiCabangAlreadyExist) {
          handleClickOpenAlertKodeKwitansiCabang();
        } else {
          setLoading(true);
          await axios.post(`${tempUrl}/auth/register`, {
            username,
            password,
            tipeUser,
            kodeMarketing,
            kodeSurveyor,
            namaPeriode,
            kodeKwitansi,
            coaKasir,
            akses: {
              jaminan,
              marketing,
              bukuBesar,
              area,
              customer,
              surveyor,
              eksekutor,
              tipe,
              warna,
              tingkatRisiko,
              kualitasPiutang,
              pengajuan,
              approval,
              buktiPencairan,
              topup,
              tebus,
              perpanjangan,
              cicilan,
              jualAgunan,
              infoNasabahGadai,
              lapTunggakan,
              lapTunggakanRinci,
              lapOutstanding,
              lapPinjamanJatuhTempo,
              lapStockSiapDijual,
              lapPenerimaan,
              lapJualBarang,
              lapOutstandingGadai,
              lapPiutangLunasGadai,
              lapPendapatanByadGadai,
              lapTopupGadai,
              lapTebusGadai,
              lapPerpanjanganGadai,
              registerFidusia,
              surveyFidusia,
              surveyManagerFidusia,
              pengajuanFidusia,
              approvalFidusia,
              buktiPencairanFidusia,
              angsuranFidusia,
              percepatanFidusia,
              hutangDendaFidusia,
              ubahHutangDendaFidusia,
              infoNasabahFidusia,
              penarikanFidusia,
              sp1,
              sp2,
              sp3,
              sPanggilan,
              sPenarikan,
              lapTunggakanFidusia,
              lapTunggakanFidusiaRinci,
              lapTotalPiutangFidusia,
              lapPinjamanJatuhTempoFidusia,
              lapPenerimaanFidusia,
              lapOutstandingFidusia,
              lapPiutangLunasFidusia,
              lapPenarikanFidusia,
              lapPendapatanByadFidusia,
              lapPoint6Bulan,
              lapNplFidusia,
              lapHutangDendaFidusia,
              lapTunggakanFidusiaOjk,
              lapTunggakanFidusiaRinciOjk,
              kasMasuk,
              kasKeluar,
              bankMasuk,
              bankKeluar,
              posting,
              unposting,
              aktivitasBukuBesar,
              neracaSaldo,
              labaRugiRekap,
              labaRugi,
              neraca,
              arusKasRekap,
              jurnalUmum,
              jurnal,
              labaRugiOjk,
              neracaOjk,
              arusKasOjk,
              cabang,
              tutupPeriode,
              gantiPeriode,
              profilUser,
              daftarUser,
              setting: settingAkses,
            },
            cabangId: kodeCabang,
            _id: user.id,
            token: user.token,
          });
          setLoading(false);
          navigate("/daftarUser");
        }
      } catch (error) {
        alert(error);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textRightSmall = {
    textAlign: screenSize >= 650 && "right",
    fontSize: "14px",
  };

  return (
    <Container>
      <h3>Utility</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah User</h5>
      <Dialog
        open={openAlertUsername}
        onClose={handleCloseAlertUsername}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Data Username Sama`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {`Username ${username} sudah ada, ganti Username!`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlertUsername}>Ok</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openAlertKodeKwitansiCabang}
        onClose={handleCloseAlertKodeKwitansiCabang}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Data Kode Kwitansi Sama`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {`Kode Kwitansi ${kodeKwitansi} di Cabang ${
              kodeCabang.split(" ", 1)[0]
            } sudah ada, ganti Kode Kwitansi!`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlertKodeKwitansiCabang}>Ok</Button>
        </DialogActions>
      </Dialog>
      <hr />
      <Card>
        <Card.Header>User</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={saveUser}>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Username <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          required
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Tipe User <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Select
                          required
                          value={tipeUser}
                          onChange={(e) => {
                            setTipeUser(e.target.value);
                          }}
                        >
                          {user.tipeUser === "OWNER/DIREKSI"
                            ? tipeUserOptionOwner.map((tipeUser) => (
                                <option value={tipeUser}>{tipeUser}</option>
                              ))
                            : tipeUserOption.map((tipeUser) => (
                                <option value={tipeUser}>{tipeUser}</option>
                              ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {tipeUser === "MARKETING" && (
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="3" style={textRight}>
                          Kode Marketing <b style={colorRed}>*</b> :
                        </Form.Label>
                        <Col sm="9">
                          <Autocomplete
                            size="small"
                            disablePortal
                            id="combo-box-demo"
                            options={marketingOptions}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                error={
                                  error && kodeMarketing.length === 0 && true
                                }
                                helperText={
                                  error &&
                                  kodeMarketing.length === 0 &&
                                  "Kode Marketing harus diisi!"
                                }
                                {...params}
                              />
                            )}
                            onChange={(e, value) => {
                              if (value) {
                                setKodeMarketing(value.label.split(" ", 1)[0]);
                              } else {
                                setKodeMarketing("");
                              }
                            }}
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                )}

                {tipeUser === "SURVEYOR" && (
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="3" style={textRight}>
                          Kode Surveyor <b style={colorRed}>*</b> :
                        </Form.Label>
                        <Col sm="9">
                          <Autocomplete
                            size="small"
                            disablePortal
                            id="combo-box-demo"
                            options={surveyorOptions}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                error={
                                  error && kodeSurveyor.length === 0 && true
                                }
                                helperText={
                                  error &&
                                  kodeSurveyor.length === 0 &&
                                  "Kode Surveyor harus diisi!"
                                }
                                {...params}
                              />
                            )}
                            onInputChange={(e, value) =>
                              setKodeSurveyor(value.split(" ", 1)[0])
                            }
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                )}

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Periode <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="9">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={periodeOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && namaPeriode.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              setNamaPeriode(value.label);
                            } else {
                              setNamaPeriode("");
                            }
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      {user.tipeUser === "OWNER/DIREKSI" ? (
                        <Form.Label column sm="3" style={textRight}>
                          Cabang <b style={colorRed}>*</b> :
                        </Form.Label>
                      ) : (
                        <Form.Label column sm="3" style={textRight}>
                          Cabang :
                        </Form.Label>
                      )}
                      <Col sm="9">
                        {user.tipeUser === "OWNER/DIREKSI" ? (
                          <Form.Select
                            required
                            value={kodeCabang}
                            onChange={(e) => {
                              setKodeCabang(e.target.value);
                            }}
                          >
                            {cabangs.map((cabang, index) => (
                              <option value={cabang.id}>
                                {cabang.id} - {cabang.namaCabang}
                              </option>
                            ))}
                          </Form.Select>
                        ) : (
                          <Form.Control
                            required
                            value={kodeCabang}
                            disabled
                            readOnly
                          />
                        )}
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>

              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRightSmall}>
                        Kode Kwitansi <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          required
                          value={kodeKwitansi}
                          onChange={(e) => setKodeKwitansi(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        COA Kasir <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="9">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={coaOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && coaKasir.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              setCoaKasir(value.label.split(" ", 1)[0]);
                            } else {
                              setCoaKasir("");
                            }
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Password <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          required
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
            <Container style={{ marginTop: 30 }}>
              <h4>Hak Akses User</h4>
              <Box sx={showDataContainer}>
                <Box sx={showDataWrapper}>
                  <Form>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox checked={checkAll} />}
                        label="Pilih Semua"
                        onChange={() => {
                          setCheckAll(!checkAll);
                          // Akses Master
                          setJaminan(!checkAll);
                          setMarketing(!checkAll);
                          setBukuBesar(!checkAll);
                          setArea(!checkAll);
                          setCustomer(!checkAll);
                          setSurveyor(!checkAll);
                          setEksekutor(!checkAll);
                          setTipe(!checkAll);
                          setWarna(!checkAll);
                          setTingkatRisiko(!checkAll);
                          setKualitasPiutang(!checkAll);
                          setCabang(!checkAll);
                          // Akses Gadai
                          setPengajuan(!checkAll);
                          setApproval(!checkAll);
                          setBuktiPencairan(!checkAll);
                          setTopup(!checkAll);
                          setTebus(!checkAll);
                          setPerpanjangan(!checkAll);
                          setCicilan(!checkAll);
                          setJualAgunan(!checkAll);
                          setInfoNasabahGadai(!checkAll);
                          // Akses Laporan Gadai
                          setLapTunggakan(!checkAll);
                          setLapTunggakanRinci(!checkAll);
                          setLapOutstanding(!checkAll);
                          setLapPinjamanJatuhTempo(!checkAll);
                          setLapStockSiapDijual(!checkAll);
                          setLapPenerimaan(!checkAll);
                          setLapJualBarang(!checkAll);
                          setLapOutstandingGadai(!checkAll);
                          setLapPiutangLunasGadai(!checkAll);
                          setLapPendapatanByadGadai(!checkAll);
                          setLapTopupGadai(!checkAll);
                          setLapTebusGadai(!checkAll);
                          setLapPerpanjanganGadai(!checkAll);
                          // Akses Fidusia
                          setRegisterFidusia(!checkAll);
                          setSurveyFidusia(!checkAll);
                          setSurveyManagerFidusia(!checkAll);
                          setPengajuanFidusia(!checkAll);
                          setApprovalFidusia(!checkAll);
                          setBuktiPencairanFidusia(!checkAll);
                          setAngsuranFidusia(!checkAll);
                          setPercepatanFidusia(!checkAll);
                          setHutangDendaFidusia(!checkAll);
                          setUbahHutangDendaFidusia(!checkAll);
                          setSp1(!checkAll);
                          setSp2(!checkAll);
                          setSp3(!checkAll);
                          setSPanggilan(!checkAll);
                          setSPenarikan(!checkAll);
                          setInfoNasabahFidusia(!checkAll);
                          setPenarikanFidusia(!checkAll);
                          // Akses Laporan Fidusia
                          setLapTunggakanFidusia(!checkAll);
                          setLapTunggakanFidusiaRinci(!checkAll);
                          setLapTotalPiutangFidusia(!checkAll);
                          setLapPinjamanJatuhTempoFidusia(!checkAll);
                          setLapPenerimaanFidusia(!checkAll);
                          setLapOutstandingFidusia(!checkAll);
                          setLapPiutangLunasFidusia(!checkAll);
                          setLapPenarikanFidusia(!checkAll);
                          setLapPendapatanByadFidusia(!checkAll);
                          setLapPoint6Bulan(!checkAll);
                          setLapNplFidusia(!checkAll);
                          setLapHutangDendaFidusia(!checkAll);
                          setLapTunggakanFidusiaOjk(!checkAll);
                          setLapTunggakanFidusiaRinciOjk(!checkAll);
                          // Finance
                          setKasMasuk(!checkAll);
                          setKasKeluar(!checkAll);
                          setBankMasuk(!checkAll);
                          setBankKeluar(!checkAll);
                          // Accounting
                          setPosting(!checkAll);
                          setUnposting(!checkAll);
                          setAktivitasBukuBesar(!checkAll);
                          setNeracaSaldo(!checkAll);
                          setLabaRugiRekap(!checkAll);
                          setLabaRugi(!checkAll);
                          setNeraca(!checkAll);
                          setArusKasRekap(!checkAll);
                          setJurnalUmum(!checkAll);
                          setJurnal(!checkAll);
                          // Accounting OJK
                          setLabaRugiOjk(!checkAll);
                          setNeracaOjk(!checkAll);
                          setArusKasOjk(!checkAll);
                          // Akses Utility
                          setProfilUser(!checkAll);
                          setDaftarUser(!checkAll);
                          setTutupPeriode(!checkAll);
                          setGantiPeriode(!checkAll);
                          setSettingAkses(!checkAll);
                        }}
                      />
                    </FormGroup>
                  </Form>
                </Box>
              </Box>
              <Box sx={showDataContainer}>
                <Box sx={showDataWrapper}>
                  <Typography variant="p" sx={[spacingTop]}>
                    Master
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={jaminan} />}
                      label="Jaminan"
                      onChange={() => setJaminan(!jaminan)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={marketing} />}
                      label="Marketing"
                      onChange={() => setMarketing(!marketing)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={bukuBesar} />}
                      label="Buku Besar"
                      onChange={() => setBukuBesar(!bukuBesar)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={area} />}
                      label="Area"
                      onChange={() => setArea(!area)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={customer} />}
                      label="Customer"
                      onChange={() => setCustomer(!customer)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={surveyor} />}
                      label="Surveyor"
                      onChange={() => setSurveyor(!surveyor)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={eksekutor} />}
                      label="Eksekutor"
                      onChange={() => setEksekutor(!eksekutor)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={tipe} />}
                      label="Tipe"
                      onChange={() => setTipe(!tipe)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={warna} />}
                      label="Warna"
                      onChange={() => setWarna(!warna)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={tingkatRisiko} />}
                      label="Tingkat Risiko"
                      onChange={() => setTingkatRisiko(!tingkatRisiko)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={kualitasPiutang} />}
                      label="Kualitas Piutang"
                      onChange={() => setKualitasPiutang(!kualitasPiutang)}
                    />
                  </FormGroup>
                  {/* <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={cabang} />}
                      label="Cabang"
                      onChange={() => setCabang(!cabang)}
                    />
                  </FormGroup> */}
                  <Typography variant="p" sx={[spacingTop]}>
                    Gadai
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={pengajuan} />}
                      label="Pengajuan"
                      onChange={() => setPengajuan(!pengajuan)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={approval} />}
                      label="Approval"
                      onChange={() => setApproval(!approval)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={buktiPencairan} />}
                      label="Bukti Pencairan"
                      onChange={() => setBuktiPencairan(!buktiPencairan)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={topup} />}
                      label="Top-Up"
                      onChange={() => setTopup(!topup)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={tebus} />}
                      label="Tebus"
                      onChange={() => setTebus(!tebus)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={perpanjangan} />}
                      label="Perpanjangan"
                      onChange={() => setPerpanjangan(!perpanjangan)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={cicilan} />}
                      label="Cicilan"
                      onChange={() => setCicilan(!cicilan)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={jualAgunan} />}
                      label="Jual Agunan"
                      onChange={() => setJualAgunan(!jualAgunan)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={infoNasabahGadai} />}
                      label="Info Nasabah"
                      onChange={() => setInfoNasabahGadai(!infoNasabahGadai)}
                    />
                  </FormGroup>
                  <Typography variant="p" sx={[spacingTop]}>
                    Laporan Gadai
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapTunggakanRinci} />}
                      label="Lap. Tunggakan Rinci"
                      onChange={() => setLapTunggakanRinci(!lapTunggakanRinci)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapTunggakan} />}
                      label="Lap. Tunggakan"
                      onChange={() => setLapTunggakan(!lapTunggakan)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapOutstanding} />}
                      label="Lap. Total Piutang"
                      onChange={() => setLapOutstanding(!lapOutstanding)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapPinjamanJatuhTempo} />}
                      label="Lap. Pinjaman Jatuh Tempo"
                      onChange={() =>
                        setLapPinjamanJatuhTempo(!lapPinjamanJatuhTempo)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapStockSiapDijual} />}
                      label="Lap. Stock Siap Dijual"
                      onChange={() =>
                        setLapStockSiapDijual(!lapStockSiapDijual)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapPenerimaan} />}
                      label="Lap. Penerimaan"
                      onChange={() => setLapPenerimaan(!lapPenerimaan)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapJualBarang} />}
                      label="Lap. Jual Barang"
                      onChange={() => setLapJualBarang(!lapJualBarang)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapOutstandingGadai} />}
                      label="Lap. Outstanding"
                      onChange={() =>
                        setLapOutstandingGadai(!lapOutstandingGadai)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapPiutangLunasGadai} />}
                      label="Lap. Piutang Lunas"
                      onChange={() =>
                        setLapPiutangLunasGadai(!lapPiutangLunasGadai)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapPendapatanByadGadai} />}
                      label="Lap. Pendapatan BYAD"
                      onChange={() =>
                        setLapPendapatanByadGadai(!lapPendapatanByadGadai)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapTopupGadai} />}
                      label="Lap. Topup"
                      onChange={() => setLapTopupGadai(!lapTopupGadai)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapTebusGadai} />}
                      label="Lap. Tebus"
                      onChange={() => setLapTebusGadai(!lapTebusGadai)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapPerpanjanganGadai} />}
                      label="Lap. Perpanjangan"
                      onChange={() =>
                        setLapPerpanjanganGadai(!lapPerpanjanganGadai)
                      }
                    />
                  </FormGroup>
                  <Typography variant="p" sx={[spacingTop]}>
                    Fidusia
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={registerFidusia} />}
                      label="Register"
                      onChange={() => setRegisterFidusia(!registerFidusia)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={surveyFidusia} />}
                      label="Survey"
                      onChange={() => setSurveyFidusia(!surveyFidusia)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={surveyManagerFidusia} />}
                      label="Survey Manager"
                      onChange={() =>
                        setSurveyManagerFidusia(!surveyManagerFidusia)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={pengajuanFidusia} />}
                      label="Pengajuan"
                      onChange={() => setPengajuanFidusia(!pengajuanFidusia)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={approvalFidusia} />}
                      label="Approval"
                      onChange={() => setApprovalFidusia(!approvalFidusia)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={buktiPencairanFidusia} />}
                      label="Bukti Pencairan"
                      onChange={() =>
                        setBuktiPencairanFidusia(!buktiPencairanFidusia)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={angsuranFidusia} />}
                      label="Angsuran"
                      onChange={() => setAngsuranFidusia(!angsuranFidusia)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={percepatanFidusia} />}
                      label="Percepatan"
                      onChange={() => setPercepatanFidusia(!percepatanFidusia)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={hutangDendaFidusia} />}
                      label="Hutang Denda"
                      onChange={() =>
                        setHutangDendaFidusia(!hutangDendaFidusia)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={ubahHutangDendaFidusia} />}
                      label="Ubah Hutang Denda"
                      onChange={() =>
                        setUbahHutangDendaFidusia(!ubahHutangDendaFidusia)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={infoNasabahFidusia} />}
                      label="Info Nasabah"
                      onChange={() =>
                        setInfoNasabahFidusia(!infoNasabahFidusia)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={penarikanFidusia} />}
                      label="Penarikan"
                      onChange={() => setPenarikanFidusia(!penarikanFidusia)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={sp1} />}
                      label="SP-1"
                      onChange={() => setSp1(!sp1)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={sp2} />}
                      label="SP-2"
                      onChange={() => setSp2(!sp2)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={sp3} />}
                      label="SP-3"
                      onChange={() => setSp3(!sp3)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={sPanggilan} />}
                      label="Surat Panggilan"
                      onChange={() => setSPanggilan(!sPanggilan)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={sPenarikan} />}
                      label="Surat Penarikan"
                      onChange={() => setSPenarikan(!sPenarikan)}
                    />
                  </FormGroup>
                </Box>
                <Box sx={[showDataWrapper, secondWrapper]}>
                  <Typography variant="p" sx={[spacingTop]}>
                    Laporan Fidusia
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapTunggakanFidusia} />}
                      label="Lap. Tunggakan"
                      onChange={() =>
                        setLapTunggakanFidusia(!lapTunggakanFidusia)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapTunggakanFidusiaRinci} />}
                      label="Lap. Tunggakan Rinci"
                      onChange={() =>
                        setLapTunggakanFidusiaRinci(!lapTunggakanFidusiaRinci)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapTotalPiutangFidusia} />}
                      label="Lap. Total Piutang"
                      onChange={() =>
                        setLapTotalPiutangFidusia(!lapTotalPiutangFidusia)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox checked={lapPinjamanJatuhTempoFidusia} />
                      }
                      label="Lap. Pinjaman Jatuh Tempo"
                      onChange={() =>
                        setLapPinjamanJatuhTempoFidusia(
                          !lapPinjamanJatuhTempoFidusia
                        )
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapPenerimaanFidusia} />}
                      label="Lap. Penerimaan"
                      onChange={() =>
                        setLapPenerimaanFidusia(!lapPenerimaanFidusia)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapOutstandingFidusia} />}
                      label="Lap. Outstanding Fidusia"
                      onChange={() =>
                        setLapOutstandingFidusia(!lapOutstandingFidusia)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapPiutangLunasFidusia} />}
                      label="Lap. Piutang Lunas"
                      onChange={() =>
                        setLapPiutangLunasFidusia(!lapPiutangLunasFidusia)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapPenarikanFidusia} />}
                      label="Lap. Penarikan"
                      onChange={() =>
                        setLapPenarikanFidusia(!lapPenarikanFidusia)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapPendapatanByadFidusia} />}
                      label="Lap. Pendapatan BYAD"
                      onChange={() =>
                        setLapPendapatanByadFidusia(!lapPendapatanByadFidusia)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapPoint6Bulan} />}
                      label="Lap. Point 6 Bulan"
                      onChange={() => setLapPoint6Bulan(!lapPoint6Bulan)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapNplFidusia} />}
                      label="Lap. NPL"
                      onChange={() => setLapNplFidusia(!lapNplFidusia)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapHutangDendaFidusia} />}
                      label="Lap. Hutang Denda"
                      onChange={() =>
                        setLapHutangDendaFidusia(!lapHutangDendaFidusia)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={lapTunggakanFidusiaOjk} />}
                      label="Lap. Tunggakan OJK"
                      onChange={() =>
                        setLapTunggakanFidusiaOjk(!lapTunggakanFidusiaOjk)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox checked={lapTunggakanFidusiaRinciOjk} />
                      }
                      label="Lap. Tunggakan Rinci OJK"
                      onChange={() =>
                        setLapTunggakanFidusiaRinciOjk(
                          !lapTunggakanFidusiaRinciOjk
                        )
                      }
                    />
                  </FormGroup>
                  <Typography variant="p" sx={[spacingTop]}>
                    Finance
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={kasMasuk} />}
                      label="Kas Masuk"
                      onChange={() => setKasMasuk(!kasMasuk)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={kasKeluar} />}
                      label="Kas Keluar"
                      onChange={() => setKasKeluar(!kasKeluar)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={bankMasuk} />}
                      label="Bank Masuk"
                      onChange={() => setBankMasuk(!bankMasuk)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={bankKeluar} />}
                      label="Bank Keluar"
                      onChange={() => setBankKeluar(!bankKeluar)}
                    />
                  </FormGroup>
                  <Typography variant="p" sx={[spacingTop]}>
                    Accounting
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={posting} />}
                      label="Posting"
                      onChange={() => setPosting(!posting)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={unposting} />}
                      label="Unposting"
                      onChange={() => setUnposting(!unposting)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={aktivitasBukuBesar} />}
                      label="Aktivitas Buku Besar"
                      onChange={() =>
                        setAktivitasBukuBesar(!aktivitasBukuBesar)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={neracaSaldo} />}
                      label="Neraca Saldo"
                      onChange={() => setNeracaSaldo(!neracaSaldo)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={labaRugiRekap} />}
                      label="Laba Rugi Rekap"
                      onChange={() => setLabaRugiRekap(!labaRugiRekap)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={labaRugi} />}
                      label="Laba Rugi"
                      onChange={() => setLabaRugi(!labaRugi)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={neraca} />}
                      label="Neraca"
                      onChange={() => setNeraca(!neraca)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={arusKasRekap} />}
                      label="Arus Kas Rekap"
                      onChange={() => setArusKasRekap(!arusKasRekap)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={jurnalUmum} />}
                      label="Jurnal Umum"
                      onChange={() => setJurnalUmum(!jurnalUmum)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={jurnal} />}
                      label="Jurnal"
                      onChange={() => setJurnal(!jurnal)}
                    />
                  </FormGroup>
                  <Typography variant="p" sx={[spacingTop]}>
                    Accounting OJK
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={labaRugiOjk} />}
                      label="Laba Rugi OJK"
                      onChange={() => setLabaRugiOjk(!labaRugiOjk)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={neracaOjk} />}
                      label="Neraca OJK"
                      onChange={() => setNeracaOjk(!neracaOjk)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={arusKasOjk} />}
                      label="Arus Kas OJK"
                      onChange={() => setArusKasOjk(!arusKasOjk)}
                    />
                  </FormGroup>
                  <Typography variant="p" sx={[spacingTop]}>
                    Utility
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={profilUser} />}
                      label="Profil User"
                      onChange={() => setProfilUser(!profilUser)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={daftarUser} />}
                      label="Daftar User"
                      onChange={() => setDaftarUser(!daftarUser)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={tutupPeriode} />}
                      label="Tutup Periode"
                      onChange={() => setTutupPeriode(!tutupPeriode)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={gantiPeriode} />}
                      label="Ganti Periode"
                      onChange={() => setGantiPeriode(!gantiPeriode)}
                    />
                  </FormGroup>
                  {user.tipeUser === "OWNER/DIREKSI" && (
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox checked={settingAkses} />}
                        label="Setting"
                        onChange={() => setSettingAkses(!settingAkses)}
                      />
                    </FormGroup>
                  )}
                </Box>
              </Box>
            </Container>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate("/daftarUser")}
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
              >
                Simpan
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default TambahUser;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const showDataContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const checkboxTitle = {
  marginBottom: 0,
};

const secondCheckboxTitle = {
  marginTop: 15,
  marginBottom: 0,
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const colorRed = {
  color: "red",
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};
